module.exports = __webpack_public_path__ + "img/zaisu_eight.16dec1c0.jpg";